/**
 * GiftIcon — sanitized from `assets/newSvg/gift.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function GiftIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12.9873,5.73973 C13.5921,5.39577 14,4.74552 14,4 C14,2.89543 13.1046,2 12,2 C10.8954,2 10,2.89543 10,4 C10,4.7472 10.4097,5.39869 11.0168,5.74205 L11.0078,5.76034 C10.3521,7.12693 9.44232,9.08475 8.03664,9.81975 C6.88336,10.4228 5.22628,10.1194 3.99634,9.8944 C3.94215,9.11525 3.29293,8.5 2.5,8.5 C1.67157,8.5 1,9.17157 1,10 C1,10.7347 1.52815,11.346 2.22548,11.4749 L5.17264,19.0836 C5.62005,20.2387 6.7314,21 7.97011,21 L16.0299,21 C17.2686,21 18.3799,20.2387 18.8274,19.0836 L21.7745,11.4749 C22.4718,11.346 23,10.7347 23,10 C23,9.17157 22.3284,8.5 21.5,8.5 C20.7223,8.5 20.0828,9.09186 20.0074,9.84973 C18.7483,10.013 17.1251,10.2213 15.9634,9.61387 C14.5859,8.89364 13.6634,7.07077 12.9873,5.73973 Z"
        fill={color}
      />
    </Svg>
  );
}

export default GiftIcon;
